import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

/**
 * Copilot user avatar (initials only) for the footer's bottom-right. Clicking it
 * opens a small menu with the user's name and a Logout action — replacing the
 * full name + standalone logout icon that used to live in the footer.
 */
const CopilotUserMenu = ({ initials = 'U', name, onLogout, menuAlign = 'right' }) => {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Avatar
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          width: 38,
          height: 38,
          bgcolor: '#fff',
          color: '#121212',
          fontSize: 17,
          fontWeight: 700,
          cursor: 'pointer',
          transition: 'box-shadow 0.15s ease',
          '&:hover': { boxShadow: '0 0 0 2px #feec67' },
        }}
      >
        {initials}
      </Avatar>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: menuAlign }}
        transformOrigin={{ vertical: 'bottom', horizontal: menuAlign }}
        slotProps={{ paper: { sx: { bgcolor: '#1e1e1e', color: '#fff', minWidth: 190, mb: 1, border: '1px solid rgba(255,255,255,0.1)' } } }}
      >
        {name && (
          <Box sx={{ px: 2, py: 1.25, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
            <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{name}</Typography>
          </Box>
        )}
        <MenuItem
          onClick={() => { setAnchor(null); onLogout?.(); }}
          sx={{ gap: 1.25, fontSize: 15, py: 1.25, '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' } }}
        >
          <LogoutRoundedIcon sx={{ fontSize: 20 }} />
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

CopilotUserMenu.propTypes = {
  initials: PropTypes.string,
  name: PropTypes.string,
  onLogout: PropTypes.func,
  menuAlign: PropTypes.oneOf(['left', 'right']),
};

export default CopilotUserMenu;
